import { render, staticRenderFns } from "./xueya.vue?vue&type=template&id=8cf117f4&scoped=true"
import script from "./xueya.vue?vue&type=script&lang=ts"
export * from "./xueya.vue?vue&type=script&lang=ts"
import style0 from "./xueya.vue?vue&type=style&index=0&id=8cf117f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf117f4",
  null
  
)

export default component.exports